import "./clients.scss";
import Pager from "components/pager";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, ClientType } from "types";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import api from "api";
import { actions } from "redux/reducers";

function Clients() {
    const history = useHistory();
    const clients = useSelector((state: RootState) => state.clients);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [numberOfElements, setNumberOfElements] = useState(12);
    const dispatch = useDispatch();

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setPage(1);
        setSearch(e.currentTarget.value);
    };

    const getNumOfElements = () => {
        if (window.innerWidth > 1400) {
            setNumberOfElements(25);
        } else if (window.innerWidth > 1200) {
            setNumberOfElements(16);
        } else {
            setNumberOfElements(12);
        }
    };

    const addClient = () => {
        history.push("client-management");
    };

    const selectClient = (client: ClientType) => {
        dispatch(actions.client.set(client));
    };

    const getClients = useCallback(async () => {
        const data = await api.clients.getAll();
        dispatch(actions.clients.set(data));
    }, [dispatch]);

    useEffect(() => {
        getClients();
        getNumOfElements();
    }, [getClients]);

    useEffect(() => {
        window.addEventListener("resize", getNumOfElements);
        return () => window.removeEventListener("resize", getNumOfElements);
    }, []);

    return (
        <div className="clients">
            <div id="top">
                Clients
                <div className="input-group">
                    <input type="text" placeholder="Search" onChange={handleSearch} />
                    <i className="fal fa-search"></i>
                </div>
                {/* <button onClick={addClient}>Add</button> */}
            </div>
            <div id="clients-container">
                {clients
                    .filter((x) => x.Name.toLowerCase().includes(search.toLowerCase()) || x.Id.toString().includes(search.toLowerCase()))
                    .slice((page - 1) * numberOfElements, (page - 1) * numberOfElements + numberOfElements)
                    .map((item) => {
                        return (
                            <Link to={`client/${item.Id}/dashboard`} key={item.Id} onClick={() => selectClient(item)}>
                                <div className="client">
                                    <span className="name" title={item.Name}>
                                        {item.Name}
                                    </span>
                                    <span className="id">{item.Id}</span>
                                    {item.IsActive === true ? <span className="active">Active</span> : <span className="inactive">In-Active</span>}

                                    <i className="fal fa-building"></i>
                                </div>
                            </Link>
                        );
                    })}
            </div>
            <div id="paging">
                <Pager elements={clients} page={page} setPage={setPage} numberOfResults={numberOfElements} />
            </div>
        </div>
    );
}

export default Clients;
